import React, { useCallback } from "react";

import { AHText, Box, ListItem } from "arkh";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { Alert, FlatList } from "react-native";
import { IntegrationTomraCreateScreenQuery } from "./__generated__/IntegrationTomraCreateScreenQuery.graphql";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";

export const IntegrationTomraCreateScreen = (
  props: StoreAdminNavigationScreenProps<"IntegrationTomraCreate">
) => (
  <LazyQueryNetworkBoundrary>
    {(fetchKey) => (
      <InnerIntegrationTomraCreateScreen {...props} fetchKey={fetchKey} />
    )}
  </LazyQueryNetworkBoundrary>
);

const InnerIntegrationTomraCreateScreen = (
  props: StoreAdminNavigationScreenProps<"IntegrationTomraCreate"> & {
    fetchKey: string;
  }
) => {
  const data = useLazyLoadQuery<IntegrationTomraCreateScreenQuery>(
    graphql`
      query IntegrationTomraCreateScreenQuery {
        store {
          name
        }
        tomraStores {
          accountId
          externalId
          name
          assigned
        }
      }
    `,
    {},
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );

  const [activate, loading] = useMutation(graphql`
    mutation IntegrationTomraCreateScreenMutation(
      $accountId: String!
      $externalStoreId: String!
    ) {
      store {
        activateIntegrationTomra(
          accountId: $accountId
          externalStoreId: $externalStoreId
        ) {
          __typename
        }
      }
    }
  `);

  const onPress = useCallback(
    ({
      accountId,
      externalId: externalStoreId,
    }: (typeof data)["tomraStores"][number]) => {
      activate({
        variables: {
          accountId,
          externalStoreId,
        },
        onCompleted: () => {
          props.navigation.replace("IntegrationTomra", {});
        },
        onError: () => {
          Alert.alert("Error");
        },
      });
    },
    [activate, props.navigation]
  );

  return (
    <Box style={{ flex: 1 }} cornerRadius="large" space="medium">
      <AHText type="title-small" spaceBottom="small">
        Connect &quot;{data.store.name}&quot; to tomra store:
      </AHText>
      <FlatList
        data={data?.tomraStores}
        renderItem={({ item, index }) => (
          <ListItem
            isFirst={index === 0}
            isLast={index + 1 === data.tomraStores?.length}
            onPress={() => onPress(item)}
            disabled={loading || item.assigned}
          >
            <ListItem.Title
              color={item.assigned ? "status-inactive" : undefined}
            >
              {item?.name ?? item?.externalId}
            </ListItem.Title>
          </ListItem>
        )}
      />
    </Box>
  );
};
